document.addEventListener('turbo:load', () => {
  const container = document.querySelector('.notice-container')
  if (container === null || container.dataset.initialized) return

  container.dataset.initialized = 'true'

  const removeNoticeContainer = () => {
    container.classList.add('dismissed')
  }

  const btn = container.querySelector('.close-x')
  setTimeout(removeNoticeContainer, 10000)
  setTimeout(() => container.classList.add('countdown'), 500)
  if (btn) btn.addEventListener('click', removeNoticeContainer)
})
